namespace SolovisGateway.Admin.EnvironmentPools {

    /**
     * AdminPoolListControl presents the user interface for administratinge environment pools.
     */
    export class AdminPoolListControl extends Solovis.UI.BaseControl {

        private _poolList;
        private _initError;

        private _toolbarContainer;
        private _toolbar: Solovis.UI.Toolbar;

        private _dataGrid: DevExpress.ui.dxDataGrid;

        constructor(options) {
            super(options);
        }

        public doInitAsync() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Admin/EnvironmentPoolAdmin/GetEnvironmentPools",
                {},
                function (response, success) {
                    if (success) {
                        self._poolList = response.result.environmentPools;
                    }
                    else {
                        console.log("ERROR: AdminPoolListControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }

                    self.notifyInitComplete();
                });
        }

        public doRender() {
            let self = this;

            this._toolbarContainer = $("<div>").appendTo(this.container);

            var toolbar = new Solovis.UI.Toolbar({
                container: this._toolbarContainer
            });
            this._toolbar = toolbar;

            toolbar.addItem({
                name: "addEnvironmentPoolButton",
                createToolbarItem: function () {
                    var addEnvironmentPoolButton = new Solovis.UI.Buttons.Button({
                        element: $("<div>").text("Add Environment Pool").prepend($("<span>").css("padding-right", "5px").addClass("fa fa-plus")),
                        size: "small",
                        click: function () {
                            self._showAddPoolInterface({
                                saveCallback: function () {
                                    self._refreshPools();
                                }
                            });
                        }
                    });

                    return addEnvironmentPoolButton;
                }
            });

            // Setup data grid
            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'id',
                data: this._poolList
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'name'
                },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: true },

                width: "100%",

                columns: [
                    {
                        caption: "Actions",
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            let envData = options.data;
                            self._buildActionsCell(container, envData);
                        },
                        width: 75
                    },
                    {
                        dataField: 'name',
                        dataType: 'string',
                        caption: 'Name',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'cloudServiceDomain',
                        dataType: 'string',
                        caption: 'Cloud Service Domain',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'id',
                        dataType: 'number',
                        caption: 'Environment Pool Id',
                        visible: false,
                        allowSorting: true,
                        width: 150
                    }
                ]
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");
        }

        private _showAddPoolInterface(options) {
            // TODO: Convert to strong reference once everything is TypeScript.
            (SolovisGateway as any).Admin.EnvironmentPools.EnvironmentPoolEditorDialog.showDialog(options);
        }


        private _buildActionsCell(container, poolData) {
            let self = this;
            let columnDiv = container;

            let editPoolLink = $("<a>").appendTo(columnDiv);
            $("<span class='fa fa-pencil'>").appendTo(editPoolLink);
            editPoolLink.attr("title", "Edit Pool");
            editPoolLink.attr(
                "href",
                Solovis.resolveUrl("~/Admin/EnvironmentPoolAdmin/Info/?poolId=" + poolData.id));    

            let registerReportsLink = $("<a>").css("padding-left", "5px").appendTo(columnDiv);
            $("<span class='fa fa-line-chart'>").appendTo(registerReportsLink);
            registerReportsLink.attr("title", "Register Reports and Data Sources");
            registerReportsLink.click(function () {
                self._registerSystemReportsInAllDataEnvironments(poolData);
            });

            let databaseVersionsLink = $("<a>").css("padding-left", "5px").appendTo(columnDiv);
            $("<span class='fa fa-database'>").appendTo(databaseVersionsLink);
            databaseVersionsLink.attr("title", "Migrate Database Versions");
            databaseVersionsLink.attr(
                "href",
                Solovis.resolveUrl("~/Admin/EnvironmentPoolAdmin/DataEnvironmentVersions?poolId=" + poolData.id));    
        }


        private _refreshPools() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Admin/EnvironmentPoolAdmin/GetEnvironmentPools",
                {},
                function (response, success) {
                    if (success) {
                        let pools = response.result.environmentPools;
                        let store = new DevExpress.data.ArrayStore({ key: 'id', data: pools });

                        self._dataGrid.option("dataSource", store);
                    }
                });
        }


        private _registerSystemReportsInAllDataEnvironments(poolData) {
            var self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Admin/EnvironmentPoolAdmin/RegisterSystemReportsInAllDataEnvironments",
                { id: poolData.id },
                function (response, success) {
                    if (success) {
                        let alertDiv = $("<div>").text("System reports registered for " + poolData.name + ".");
                        Solovis.UI.alert(alertDiv);
                    }
                });
        }
    }
}